import { useError } from '@composables/useError';

let error;

/**
 *
 * @param {Error} err
 * @returns {void} - This function does not return anything
 */
function handleError(err) {
  error.showModalError(err);
}

/**
 * Composable for handling errors
 * @returns {{handleError: Function}} - An object containing the 'handleError' function
 */
export default function useErrorsHandler() {
  error = useError();

  return {
    handleError,
  };
}
